import SongsPage from '@edx/pages/songs';

export { getStaticProps } from '@edx/pages/songs';

export default SongsPage;
